import { render } from "./Consejo_ConsPerf.vue?vue&type=template&id=330f1bea"
import script from "./Consejo_ConsPerf.vue?vue&type=script&lang=js"
export * from "./Consejo_ConsPerf.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__